/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IAny, IGeneric, MSDyn365Commerce, msdyn365Commerce } from '@msdyn365-commerce/core-internal';
import * as React from 'react';
import { IBinding, IModuleBinder, IMSDyn365CommerceWithPrototype } from './models';

export const initializeApp = (bindings: IBinding) => {
    /**
     * Why we are using 'Prototype'. MSDyn365Commerce is defined in core packages and used in modules and C1 development.
     * whereas all registration, build information, commerce details etc available in runtime-internal package.
     * prototype help us declaring properties in core package and implementation in runtime-internal package.
     *
     * Following properties are not accessible by module or c1 developer.
     */
    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.bindings = bindings;

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.moduleBinder = function(name: string): IModuleBinder {
        return this.bindings && this.bindings.modules && this.bindings.modules[name && name.toLowerCase()];
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.viewBinder = function(name: string): React.FC {
        return this.bindings && this.bindings.views && this.bindings.views[name];
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.componentBinder = function(name: string): React.FC {
        return this.bindings && this.bindings.components && this.bindings.components[name];
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.getPartnerOverrideAction = function(id: string): Function {
        return this.bindings && this.bindings.partnerDataActions && this.bindings.partnerDataActions[id];
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.dataAction = function(name: string): Function {
        return (
            (this.bindings && this.bindings.partnerDataActions && this.bindings.partnerDataActions[name]) ||
            (this.bindings && this.bindings.dataActions && this.bindings.dataActions[name])
        );
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.getConnector = function(name: string): any {
        return this.bindings && this.bindings.connectors && this.bindings.connectors[name];
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.getAllModuleBinder = function(): IModuleBinder[] {
        return this.bindings && this.bindings.modules && Object.values(this.bindings.modules);
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Returns an npm package source.
    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.perfAnalysisBinder = function(): any {
        return this.bindings?.perfAnalysisLibBinding;
    };

    (<IMSDyn365CommerceWithPrototype>MSDyn365Commerce).prototype.updatePrivateVariable = function(): void {
        // @ts-ignore -- accessing a private class variable which is a valid JS
        this._env = process.env.NODE_ENV;
    };

    (<IGeneric<IAny>>msdyn365Commerce).updatePrivateVariable();
};
